import { betterFetch as defaultFetch } from '@e-socna/better-fetch';
import type { BetterFetch } from '@e-socna/better-fetch';

import { geoRetryStrategy } from './strategies/retry.strategy';
import type { GEO_RATE_LIMITS } from './constants/rate-limits.constant';

/**
 * Create a configured fetcher for geo API with automatic retry handling
 *
 * @param serviceType - Type of geo service (adminDivision, geocodingSimple, etc.)
 * @param fetch - Optional custom fetch implementation (defaults to betterFetch)
 * @returns A configured fetch function with retry strategy
 *
 * @example
 * ```typescript
 * import { createGeoFetcher } from '@e-socna/gis';
 *
 * const geoFetch = createGeoFetcher('adminDivision');
 * const data = await geoFetch<AdministrativeDivision>(url);
 * ```
 */
export const createGeoFetcher =
  (
    serviceType: keyof typeof GEO_RATE_LIMITS,
    fetch: BetterFetch = defaultFetch,
  ) =>
  <T>(url: string, options?: RequestInit) =>
    fetch<T>(url, options ?? {}, {
      retryStrategy: geoRetryStrategy(serviceType),
      retries: 5,
    });
